module.exports = __webpack_public_path__ + "static/img/tab-ten-active.216c6776.png";